// 2026-09-23 - FormuLearning - 진행 중 작업 헤더 표시 (이슈 #82)
// 파일 위치: frontend/src/components/feedback/BusyIndicator.tsx
// `busyStore` 의 진행 중 작업을 헤더에 보인다 — «Step 1 검색 · 7개 중 3개 완료 · 제조사 (DMF) 진행 중 [Break]».
// 작업 소유 카드가 스크롤로 화면 밖에 있어도 진행을 보고 끊을 수 있게 한다. 문구를 누르면 소유 카드로 스크롤.
// Break 는 소유 카드의 중단 함수(확인창 포함)를 그대로 부른다. 새로고침·탭 닫기 경고는 `AppShell` 이 맡는다.

import { useBusyStore } from '../../stores/busyStore'

export default function BusyIndicator() {
  const task = useBusyStore((s) => s.task)

  if (!task) return null
  const { progress } = task
  const breaking = task.phase === 'breaking'
  const detail = breaking
    ? '중단하는 중'
    : progress
      ? `${progress.total}개 중 ${progress.done}개 완료 · ${progress.doing} 진행 중`
      : '진행 중'

  return (
    <div
      className="flex items-center gap-2 rounded-full px-3 py-1 text-[11px]"
      style={{ background: 'var(--bg-input)' }}
      data-testid="busy-indicator"
    >
      <button
        onClick={() => document.getElementById(`step-${task.step}`)?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
        className="flex items-center gap-1.5 text-text-body"
        title="진행 중인 카드로 이동"
      >
        <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full" style={{ background: 'var(--color-accent-purple)' }} />
        <span className="font-semibold">{task.label}</span>
        <span className="text-text-secondary">· {detail}</span>
      </button>
      {task.cancel && (
        <button
          onClick={task.cancel}
          disabled={breaking}
          className="rounded px-2 py-0.5 text-[10px] font-semibold text-red-400 transition-colors hover:bg-red-500/10 disabled:opacity-50"
        >
          {breaking ? 'Breaking...' : 'Break'}
        </button>
      )}
    </div>
  )
}
